import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { cloudinaryUrl } from '../utils/cloudinary';
import { formatPrice } from '../utils/formatPrice';
import { CATEGORY_LABELS } from '../utils/constants';

const ImgPlaceholder = () => (
  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--coral-light) 0%, var(--peach-light) 100%)' }}>
    <svg width="56" height="56" viewBox="0 0 64 64" fill="none" opacity="0.25">
      <circle cx="16" cy="44" r="12" stroke="var(--coral)" strokeWidth="3"/>
      <circle cx="48" cy="44" r="12" stroke="var(--coral)" strokeWidth="3"/>
      <path d="M16 44 L28 20 L36 28 L42 20 L48 44" stroke="var(--coral)" strokeWidth="3" fill="none" strokeLinejoin="round"/>
    </svg>
  </div>
);

export default function ProductCard({ product }) {
  const [imgError, setImgError] = useState(false);

  const isElektromos = product.category_slug === 'elektromos';
  const isOutOfStock = product.stock === 0;
  const catLabel     = CATEGORY_LABELS[product.category_slug] || product.category_name || product.category_slug;
  const showImg      = product.image_url && !imgError;

  return (
    <Link to={`/kerekparok/${product.slug}`} className="product-card" style={{ display: 'block' }}>
      <div className="product-card__img-wrap">
        {showImg ? (
          <img className="product-card__img" src={cloudinaryUrl(product.image_url, { width: 800 })}
            alt={product.name} loading="lazy" onError={() => setImgError(true)} />
        ) : (
          <ImgPlaceholder />
        )}

        <div className="product-card__badges">
          {isElektromos && <span className="badge badge-peach">⚡ Egyedi ajánlat</span>}
          {!isElektromos && isOutOfStock && <span className="badge badge-error">Elfogyott</span>}
          {!isElektromos && !isOutOfStock && product.stock <= 3 && product.stock > 0 && (
            <span className="badge badge-peach">Utolsó {product.stock} db</span>
          )}
        </div>
      </div>

      <div className="product-card__body">
        {catLabel && <p className="product-card__cat">{catLabel}</p>}
        <h3 className="product-card__name">{product.name}</h3>

        <div className="product-card__price-row">
          {isElektromos ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 'var(--fs-xs)', fontWeight: 600, color: 'var(--coral)', background: 'var(--coral-light)', borderRadius: 'var(--r-full)', padding: '5px 10px' }}>
              Kapcsolatfelvétel →
            </span>
          ) : !isOutOfStock && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 'var(--fs-xs)', fontWeight: 600, color: 'var(--coral)', background: 'var(--coral-light)', borderRadius: 'var(--r-full)', padding: '5px 10px' }}>
              Részletek →
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
